import dayjs from 'dayjs';

export const getRelevantNutritionPlan = (plans, now = dayjs()) => {
    const today = dayjs(now);
    const available = plans.filter(
        (plan) =>
            dayjs(plan.start_date).isValid() &&
            dayjs(plan.end_date).isValid() &&
            !dayjs(plan.end_date).isBefore(today, 'day')
    );
    const active = available.filter(
        (plan) => plan.accepted && !dayjs(plan.start_date).isAfter(today, 'day')
    );
    if (active.length)
        return active.sort(
            (a, b) => dayjs(b.start_date).valueOf() - dayjs(a.start_date).valueOf()
        )[0];
    return available.sort(
        (a, b) => dayjs(a.start_date).valueOf() - dayjs(b.start_date).valueOf()
    )[0];
};
